import * as React from "react";
import Svg, { G, Path, Defs, Rect } from "react-native-svg";

export function AlertCircleIcon(props: any) {
  return (
    <Svg width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}>
      <G clip-path="url(#clip0_1144_6313)">
        <Path
          d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z"
          stroke="#BD4400"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M6 4V6"
          stroke="#BD4400"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <Path
          d="M6 8H6.005"
          stroke="#BD4400"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </G>
      <Defs>
        <clipPath id="clip0_1144_6313">
          <Rect width="12" height="12" fill="white" />
        </clipPath>
      </Defs>
    </Svg>
  );
}
